import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ListaComponent} from "./pages/lista/lista.component";
import {NovoComponent} from "./pages/novo/novo.component";
import {DetalheComponent} from "./pages/detalhe/detalhe.component";

const routes: Routes = [
  { path: "", component: ListaComponent },
  { path: "novo", component: NovoComponent },
  { path: "detalhes/:id", component: DetalheComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentoProcessoRoutingModule { }
